import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dataTableInjectionKey as g } from "../interface.js";
import { shouldUseArrayInSingleMode as d } from "../utils.js";
import v from "../../../_mixins/use-config.js";
import { useRtl as R } from "../../../_mixins/use-rtl.js";
import f from "../../../button/src/Button.js";
import k from "../../../_internal/scrollbar/src/Scrollbar.js";
import x from "../../../checkbox/src/CheckboxGroup.js";
import A from "../../../checkbox/src/Checkbox.js";
import V from "../../../radio/src/RadioGroup.js";
import G from "../../../radio/src/Radio.js";
import { defineComponent as N, inject as O, computed as s, h as l } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as q } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const I = N({
  name: "DataTableFilterMenu",
  props: {
    column: {
      type: Object,
      required: !0
    },
    radioGroupName: {
      type: String,
      required: !0
    },
    multiple: {
      type: Boolean,
      required: !0
    },
    value: {
      type: [Array, String, Number],
      default: null
    },
    options: {
      type: Array,
      required: !0
    },
    onConfirm: {
      type: Function,
      required: !0
    },
    onClear: {
      type: Function,
      required: !0
    },
    onChange: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const {
      mergedClsPrefixRef: u,
      mergedRtlRef: a
    } = v(e), n = R("DataTable", a, u), {
      mergedClsPrefixRef: o,
      mergedThemeRef: t,
      localeRef: c
    } = O(g), i = q(e.value), h = s(() => {
      const {
        value: r
      } = i;
      return Array.isArray(r) ? r : null;
    }), p = s(() => {
      const {
        value: r
      } = i;
      return d(e.column) ? Array.isArray(r) && r.length && r[0] || null : Array.isArray(r) ? null : r;
    });
    function m(r) {
      e.onChange(r);
    }
    function C(r) {
      e.multiple && Array.isArray(r) ? i.value = r : d(e.column) && !Array.isArray(r) ? i.value = [r] : i.value = r;
    }
    function y() {
      m(i.value), e.onConfirm();
    }
    function b() {
      e.multiple || d(e.column) ? m([]) : m(null), e.onClear();
    }
    return {
      mergedClsPrefix: o,
      rtlEnabled: n,
      mergedTheme: t,
      locale: c,
      checkboxGroupValue: h,
      radioGroupValue: p,
      handleChange: C,
      handleConfirmClick: y,
      handleClearClick: b
    };
  },
  render() {
    const {
      mergedTheme: e,
      locale: u,
      mergedClsPrefix: a
    } = this;
    return l("div", {
      class: [`${a}-data-table-filter-menu`, this.rtlEnabled && `${a}-data-table-filter-menu--rtl`]
    }, l(k, null, {
      default: () => {
        const {
          checkboxGroupValue: n,
          handleChange: o
        } = this;
        return this.multiple ? l(x, {
          value: n,
          class: `${a}-data-table-filter-menu__group`,
          onUpdateValue: o
        }, {
          default: () => this.options.map((t) => l(A, {
            key: t.value,
            theme: e.peers.Checkbox,
            themeOverrides: e.peerOverrides.Checkbox,
            value: t.value
          }, {
            default: () => t.label
          }))
        }) : l(V, {
          name: this.radioGroupName,
          class: `${a}-data-table-filter-menu__group`,
          value: this.radioGroupValue,
          onUpdateValue: this.handleChange
        }, {
          default: () => this.options.map((t) => l(G, {
            key: t.value,
            value: t.value,
            theme: e.peers.Radio,
            themeOverrides: e.peerOverrides.Radio
          }, {
            default: () => t.label
          }))
        });
      }
    }), l("div", {
      class: `${a}-data-table-filter-menu__action`
    }, l(f, {
      size: "tiny",
      theme: e.peers.Button,
      themeOverrides: e.peerOverrides.Button,
      onClick: this.handleClearClick
    }, {
      default: () => u.clear
    }), l(f, {
      theme: e.peers.Button,
      themeOverrides: e.peerOverrides.Button,
      type: "primary",
      size: "tiny",
      onClick: this.handleConfirmClick
    }, {
      default: () => u.confirm
    })));
  }
});
export {
  I as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/HeaderButton/FilterMenu.js
// module id = 1602
// module chunks = 41